module.exports = __webpack_public_path__ + "img/red_delete.fff86b55.svg";